/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {AnalyticsIds} from '@ion/core/src/analytics/types';
import {setIncludeSCDevices} from '@/store/actions/groups-filter';
import {ReportsMode} from '../types/redux';

/**
 * React Hook to provide util functions for loading SC Devices in the Tree.
 *
 *  ```typescript
 *
 *   import {useSCDevices} from '../../hooks/';
 *
 *   const onCheckIncludeSCDevices = useSCDevices();
 *
 *  ```
 */
export const useSCDevices = () => {
  const dispatch = useDispatch();

  const getReportType = (elementId) => {
    if (elementId === AnalyticsIds.assetHistoryGroupFilter) {
      return ReportsMode.AssetHistory;
    };
    return ReportsMode.ShipmentHistory;
  };

  const onCheckIncludeSCDevices = useCallback(function(state: boolean, elementId = '') {
    dispatch(setIncludeSCDevices(state, getReportType(elementId)));
  }, []);

  return onCheckIncludeSCDevices;
};
